import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EnelXGui } from 'gui-com-lib';
import {
  StyledForm, Header, Text, StyledButton, Divider,
} from '../../main.styled';
import { confirmationOffer } from '../../api';
import { toastError } from '../common/ToastError';
import { CustomModal } from '../CustomModal';
import { isItalianFiscalCode, isPodNumber } from '../../utils/formValidation';
import { STATUS_CODE_200_MAPPER, HEADER_MESSAGE, STATUS_CODE_ERROR_MAPPER } from './utils';

const { SingleInput, Button } = EnelXGui.EnelXGuiAtoms;

const { Loader } = EnelXGui.EnelXGuiComponents;

const SplitHome = () => {
  const { t } = useTranslation();
  const params = new URLSearchParams(document.location.search);
  const [isFetching, setIsFetching] = useState(false);
  const [fiscalCode, setFiscalCode] = useState(null);
  const [registering, setRegistering] = useState(true);
  const [modalResult, setModalResult] = useState(false);
  const [statusCode, setStatusCode] = useState('');
  const [pod, setPod] = useState(null);

  const errorMessageParam = params.get('errorMessage');
  let headerMessage;
  if (errorMessageParam === 'INACTIVE') {
    headerMessage = HEADER_MESSAGE.INACTIVE;
  } else if (errorMessageParam === 'INACTIVE_MESSAGE') {
    headerMessage = HEADER_MESSAGE.INACTIVE_MESSAGE;
  } else {
    headerMessage = HEADER_MESSAGE.NORMAL;
  }

  const url = 'https://www.enel.it/it-it/elettrodomestici/enel-casa?ecid=referral-samsung-smart_things-link_intro-null';

  if (headerMessage === HEADER_MESSAGE.INACTIVE_MESSAGE) {
    return (
      <CustomModal
        width="432px"
        height="auto"
        position="relative"
        render={() => (
          <>
            <Header>{t(headerMessage)}</Header>
            <Text bold>
              {t('Per verificare i termini e le condizioni dell’offerta, visita il ')}
              <a href={url} target="_blank" rel="noopener noreferrer">sito</a>
              {t('. In alternativa, puoi contattare il nostro servizio di assistenza per ricevere supporto.')}
            </Text>
          </>
        )}
      />
    );
  }

  const filters = {
    fiscalCode,
    pod,
    productFamily: 'SPLIT_HOME',
  };

  const body = { ...filters };
  const headers = {};
  const requestParams = { api_key: process.env.REACT_APP_API_KEY };

  const confirmOffer = async () => {
    if (!fiscalCode || !pod) {
      return toastError(t('Codice fiscale e POD sono obbligatori'));
    }

    if (!isItalianFiscalCode(fiscalCode)) {
      return toastError('Codice fiscale non valido');
    }

    if (!isPodNumber(pod)) {
      return toastError(t('POD non conforme'));
    }

    try {
      setIsFetching(true);
      const answer = await confirmationOffer(body, headers, requestParams);
      setStatusCode(answer?.data?.status_code?.code);
      setModalResult(true);
      setRegistering(false);
      return setIsFetching(false);
    } catch (err) {
      setIsFetching(false);
      return toastError(t(STATUS_CODE_ERROR_MAPPER[err?.response?.data?.status_code?.description] || err));
    }
  };

  const onClose = () => {
    setRegistering(true);
    setModalResult(false);
    setFiscalCode('');
    setPod('');
  };

  return (
    <>
      {isFetching && <Loader isSpinning />}
      {registering && (
        <CustomModal
          width="432px"
          height="auto"
          position="relative"
          render={() => (
            <>
              <Header>{t(headerMessage)}</Header>
              <StyledForm>
                <Header anchor>{t('Fiscal_code')}</Header>
                <SingleInput
                  width="100%"
                  type="email"
                  value={fiscalCode}
                  placeholder={t('fiscal_code_placeholder')}
                  onChange={(e) => setFiscalCode(e)}
                />

                <Header anchor>{t('POD')}</Header>
                <SingleInput
                  width="100%"
                  type="email"
                  value={pod}
                  placeholder={t('pod_placeholder')}
                  onChange={(e) => setPod(e)}
                />

                <Divider />

                <StyledButton>
                  <Button
                    btnText={t('ATTIVA L\'OFFERTA')}
                    width="200px"
                    btnType="primary"
                    onClick={confirmOffer}
                  />
                </StyledButton>
              </StyledForm>
            </>
          )}
        />
      )}
      {modalResult && (
        <CustomModal
          height="auto"
          width="432px"
          className="modal"
          closeIcon
          closeModal={onClose}
          render={() => (
            <>
              <Header medium center>
                {t(STATUS_CODE_200_MAPPER[statusCode])}
              </Header>
              <StyledButton>
                <Button
                  btnType="primary"
                  btnText={t('NUOVA ATTIVAZIONE')}
                  onClick={onClose}
                />
              </StyledButton>
            </>
          )}
        />
      )}
    </>
  );
};

export { SplitHome };
